import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useEffect } from 'react'
import { savePolygon } from '../services/mapServices'

export function useSectionUpdate() {
  const queryClient = useQueryClient()

  const {
    mutate: sectionUpdate,
    isLoading: isLoadingSectionUpdate,
    error,
    isSuccess,
  } = useMutation({
    mutationFn: savePolygon,
  })

  useEffect(() => {
    if (isSuccess) {
      queryClient.removeQueries({ queryKey: ['SectionsList'] })
      queryClient.removeQueries({ queryKey: ['mapsList'] })
      queryClient.removeQueries({ queryKey: ['Map'] })
      queryClient.removeQueries({ queryKey: ['section'] })
      queryClient.removeQueries({ queryKey: ['dynamic-motions'] })
    }
  }, [isSuccess, queryClient])

  return {
    sectionUpdate,
    isLoadingSectionUpdate,
    error,
    isSuccessSectionUpdate: isSuccess,
  }
}